import { DropdownList, NumericInput, OmegaComponent, events } from "@omegagrid/core";
import { DynamicPeriodBoundry } from "../../model/period";
import { html, css } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { msg } from "@omegagrid/localize";

const PERIOD_TYPES: Record<(DynamicPeriodBoundry | ''), string> = {
	'D': 'D',
	'W': 'W',
	'M': 'M',
	'Q': 'Q',
	'Y': 'Y',
	'' : '-'
};

@customElement('rp-filters-relativeperiod')
export class RelativePeriod extends OmegaComponent {

	static styles = [OmegaComponent.styles, css`
		:host {
			display: flex;
			align-items: center;
			gap: 4px;
			height: 22px;
		}

		:host > * {
			height: 100%;
		}

		og-dropdown-list {
			flex: 0 0 40px;
			text-align: center;
		}

		og-numericinput {
			flex: 1;
			text-align: center;
			border: 1px solid var(--og-colortype-accent-border-color);
		}
	`];

	@property({type: Array})
	boundries: (DynamicPeriodBoundry | '')[] = ['', 'Y', 'Q', 'M', 'D'];

	@property({type: String})
	value: string = '-1Y';

	@query('og-dropdown-list.boundry')
	boundry: DropdownList;

	@query('og-numericinput.offset')
	offset: NumericInput;

	private _offsetValue: number;
	private _boundryValue: (DynamicPeriodBoundry | '');

	get numberFormat() {
		return '+#,0.#####' + (this._boundryValue ? `"${this._boundryValue}"` : "");
	}

	constructValue() {
		const parts: string[] = [];
		parts.push(this.offset.value >= 0 ? `+${this.offset.value}` : `${this.offset.value}`);
		if (this.boundry.value) parts.push(this.boundry.value as string);
		return parts.join('');
	}

	willUpdate(props: Map<string, any>) {
		const m = /([+-]?)(\d+)([YQMWD]?)/i.exec(this.value);
		this._offsetValue = m ? parseInt(m[1] + m[2], 10) : 0;
		this._boundryValue = m ? m[3] as (DynamicPeriodBoundry | '') : '';
	}

	_onChange = () => {
		this.value = this.constructValue() || null;
		this.dispatchEvent(new events.ChangeEvent({value: this.value}));
	}

	render = () => html`
		<og-numericinput
			buttons
			class="offset"
			.format="${this.numberFormat}"
			.value="${this._offsetValue}"
			@change="${this._onChange}">
		</og-numericinput>

		<og-dropdown-list
			noCaret
			class="boundry"
			.value="${this._boundryValue}"
			.items="${this.boundries.map(boundry => ({key: boundry, value: msg(PERIOD_TYPES[boundry] || '-')}))}"
			@change="${this._onChange}">
		</og-dropdown-list>
	`;

}
